export const FETCH_SHOWS = 'FETCH_SHOWS_CATEGORIES';
export const FETCH_MOVIES = 'FETCH_MOVIES_CATEGORIES';
